import React from 'react';
import { _cs } from '@togglecorp/fujs';
import styles from './styles.css.js';
import { genericMemo } from '../../utils/index.js';

const styleMap = {
  accent: styles.accent,
  complement1: styles.complement1,
  complement2: styles.complement2,
  complement3: styles.complement3
};

function InformationCardFragments(props) {
  const {
    icon,
    value,
    label,
    iconContainerClassName,
    valueAndLabelContainerClassName,
    valueContainerClassName,
    labelContainerClassName,
    coloredBackground,
    variant = 'accent'
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, icon && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.iconContainer, iconContainerClassName, coloredBackground && styles.coloredBackground, styleMap[variant])
  }, icon), /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.valueAndLabelContainer, valueAndLabelContainerClassName, coloredBackground && styles.coloredBackground, styleMap[variant])
  }, /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.value, valueContainerClassName)
  }, value), label && /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.label, labelContainerClassName)
  }, label)));
}

var InformationCardFragments$1 = genericMemo(InformationCardFragments);

export { InformationCardFragments$1 as default };
//# sourceMappingURL=index.js.map
